import { render, staticRenderFns } from "./patient-table.vue?vue&type=template&id=3c88a731"
import script from "./patient-table.vue?vue&type=script&lang=js"
export * from "./patient-table.vue?vue&type=script&lang=js"
import style0 from "./patient-table.vue?vue&type=style&index=0&id=3c88a731&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locale/current-stationary-localization.json?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CUsers%5Cnikod%5CDocuments%5Cgithub%5Cnikodz%5CWebmed.Core.VueJS%5Csrc%5Ccomponent%5Cpatient-history%5Cpatient-table.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locale/person-localization.json?vue&type=custom&index=1&blockType=i18n&issuerPath=C%3A%5CUsers%5Cnikod%5CDocuments%5Cgithub%5Cnikodz%5CWebmed.Core.VueJS%5Csrc%5Ccomponent%5Cpatient-history%5Cpatient-table.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports